import { EnvironmentModel } from './environment.model';

export const environment: EnvironmentModel = {
  apiUrls: {
    baseUrl: 'https://api.cug.intelous.ai/api',
  },
  message: 'this build targets PREPROD And CUG environments',
  production: true,
  storageKey: '7df365dc5f3cd4c7f846f886fb9166b871aeb66271ca27236f68e22f4b45fde0', // 32 characters for AES-256
};
